import React, { useState, useEffect } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { useHistory, useLocation } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import { useAuthDataContext } from '../../../../_providers/Auth'
import moment from 'moment'
import { Avatar } from '@mui/material'

function LatestReservations({ statusFilter, onClearFilter }) {

    const auth = useAuthDataContext()
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        loading: true,
        data: []
    })

    const loadLatestReservations = () => {
        setState(prev => ({ ...prev, loading: true }))

        const endpoint = statusFilter
            ? `reservations/latest?status_filter=${encodeURIComponent(statusFilter.id)}`
            : 'reservations/latest'

        Api.get(endpoint)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    useEffect(() => {
        loadLatestReservations()
    }, [statusFilter])

    useEffect(() => {
        // Listen for reservation accepted events
        const handleReservationAccepted = (event) => {
            console.log('Reservation accepted, refreshing latest reservations:', event.detail)
            loadLatestReservations()
        }

        window.addEventListener('reservationAccepted', handleReservationAccepted)

        return () => {
            window.removeEventListener('reservationAccepted', handleReservationAccepted)
        }
    }, [statusFilter])

    const handleShowUpcomingReservations = performer => {

        if (!auth.module('gps')) {
            return
        }

        if (performer && performer.type === 'App\\Employee' || performer.type === 'App\\Models\\Employee') {
            searchParams.set('show_upcoming_reservations', performer.id)

            let url = '?' + searchParams.toString()

            history.replace(url)
        }
    }

    return (
        <>
            <div className='head'>
                <h3 >
                    {trans('random.lastReservations')}
                    {statusFilter && (
                        <span
                            style={{
                                paddingLeft: "8px"
                            }}
                        >
                            - {trans('random.filteredBy')} {statusFilter.name}
                        </span>
                    )}
                </h3>
            </div>
            {state.loading
                ?
                <Skeleton height={55} count={3} />
                :
                state.data.length === 0
                    ?
                    <div
                        className="alert info"
                        style={{
                            marginBottom: 0,
                            width: '100%',
                        }}
                    >
                        {trans("messages.noDataFound")}
                    </div>
                    :
                    <div className="table-scroller">
                        <table className="latest-reservations-table">
                            <thead className="table-header">
                                <tr>
                                    <th className="header-cell">{trans('tables.date')}</th>
                                    <th className="header-cell">{trans('tables.setTo')}</th>
                                    <th className="header-cell">{trans('tables.client')}</th>
                                    <th className="header-cell">{trans('tables.address')}</th>
                                    <th className="header-cell">{trans('tables.paidPrice')}</th>
                                    <th className="header-cell">{trans('tables.finalPrice')}</th>
                                    <th className="header-cell">{trans('tables.status')}</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {state.data.map((row, index) =>
                                    <tr key={'r-' + row.id} className="table-row">
                                        <td className="table-cell date-cell">
                                            {moment(row.created_at).format('DD MMM YYYY / HH:mm')}
                                        </td>
                                        <td>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px"
                                                }}
                                            >
                                                <Avatar
                                                    alt={row.performer?.name || '?'}
                                                    avatar={row.performer?.avatar || null}
                                                    sx={{
                                                        width: "25px",
                                                        height: "25px",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {row.performer ? row.performer?.name.charAt(0) : '?'}
                                                </Avatar>
                                                {row.performer
                                                    ?
                                                    row.performer.type === 'App\\Employee' || row.performer.type === 'App\\Models\\Employee'
                                                        ? `${row.performer.name} ${row.performer.lastname?.[0] || ''}.`
                                                        : `${row.performer.name}`
                                                    :
                                                    trans('random.unknownPerson')
                                                }
                                            </div>
                                        </td>
                                        <td className="table-cell client-cell">
                                            {row.customer?.name} {row.customer?.lastname}
                                        </td>
                                        <td className="table-cell address-cell">
                                            {row.address || ''}
                                        </td>
                                        <td className="table-cell amount-cell">
                                            {row.paid_price_formatted || ''} {row.currency?.name || ''}
                                        </td>
                                        <td className="table-cell amount-cell">
                                            {row.total_price_formatted || ''} {row.currency?.name || ''}
                                        </td>
                                        <td className="table-cell status-cell">
                                            {row.finalstatus?.translation?.name || (index % 2 === 0 ? 'Завършена' : 'Отказана')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
            }
        </>
    )
}

export default LatestReservations